module.exports = __webpack_public_path__ + "static/media/moon.cc4173ef.svg";